"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MintLootBoxDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const types_1 = require("@framework/types");
const mui_dialog_form_1 = require("@dzambalaorg/mui-dialog-form");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const inputs_1 = require("../../../../../../inputs");
const box_content_1 = require("../../../box-content");
const validation_1 = require("./validation");
const MintLootBoxDialog = (props) => {
    const { initialValues, ...rest } = props;
    return ((0, jsx_runtime_1.jsxs)(mui_dialog_form_1.FormDialog, { initialValues: initialValues, validationSchema: validation_1.validationSchema, message: "dialogs.mintToken", testId: "MintForm", disabled: false, ...rest, children: [(0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { required: true, name: "contractId", controller: "contracts", fetchData: {
                    contractType: [types_1.TokenType.ERC721],
                    contractModule: [types_1.ModuleType.LOOT],
                }, autoSelect: true, disableClear: true }), (0, jsx_runtime_1.jsx)(inputs_1.LootBoxInput, {}), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "account", required: true }), (0, jsx_runtime_1.jsx)(box_content_1.BoxContent, {})] }));
};
exports.MintLootBoxDialog = MintLootBoxDialog;
//# sourceMappingURL=index.js.map